
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import getBuiltIn$1 from './get-built-in.js';
import functionUncurryThis from './function-uncurry-this.js';
import './object-get-own-property-names.js';
import './object-get-own-property-symbols.js';
import anObject$1 from './an-object.js';
import { __exports as objectGetOwnPropertyNames } from '../../../_virtual/object-get-own-property-names.js';
import { __exports as objectGetOwnPropertySymbols } from '../../../_virtual/object-get-own-property-symbols.js';

var getBuiltIn = getBuiltIn$1;
var uncurryThis = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var anObject = anObject$1;

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

export { ownKeys as default };
//# sourceMappingURL=own-keys.js.map
